import React, { useState } from 'react';
import {
  View,
  Text,
  ScrollView,
  Image,
  TouchableOpacity,
  useColorScheme,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const ExperienceDetailScreen = ({ route, navigation }) => {
  const { experienceId } = route.params;
  const isDarkMode = useColorScheme() === 'dark';
  const [likeCount, setLikeCount] = useState(128);
  const [commentCount, setCommentCount] = useState(36);
  const [isLiked, setIsLiked] = useState(false);

  // 模拟经验心得数据 - 实际应用中应基于experienceId获取
  const experience = {
    id: experienceId,
    title: '我的低碳饮食减重历程',
    content: `在过去三个月里，我尝试了低碳饮食法，并成功减重10公斤。这段旅程充满挑战但也非常有价值。

我的饮食原则很简单：减少碳水化合物摄入，增加蛋白质和健康脂肪的比例。每天的碳水摄入控制在50克以下，主要来源是蔬菜和少量浆果。

刚开始的两周是最困难的，我经历了所谓的"碳水戒断症状"，包括头痛、疲劳和易怒。但坚持过这段时间后，我的能量水平反而提高了，思维也更加清晰。

最令我惊讶的是，低碳饮食后我几乎没有饥饿感。高蛋白和高脂肪的食物提供了持久的饱腹感，这让我能轻松保持热量赤字而不感到痛苦。

除了体重减轻，我还注意到以下变化：
- 血糖水平更加稳定，不再有下午的能量崩溃
- 皮肤状况改善
- 睡眠质量提高
- 运动表现提升

对于想尝试低碳饮食的朋友，我的建议是：
1. 循序渐进，不要一下子将碳水减至极低
2. 确保摄入足够的电解质，特别是钠、钾和镁
3. 多喝水
4. 关注蔬菜摄入，确保营养均衡
5. 耐心等待适应期过去
    
低碳饮食可能不适合所有人，如果你有任何健康问题，请在开始前咨询医生的建议。`,
    images: [
      'https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1515543237350-b3eea1ec8082?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
    ],
    tags: ['减重', '低碳饮食', '健康生活'],
    user: {
      name: '李健康',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      bio: '健康生活倡导者 | 减重成功人士 | 业余营养爱好者',
      followers: 583,
    },
    likes: 128,
    comments: 36,
    time: '2023年5月15日',
    comments_data: [
      {
        id: 'c1',
        user: {
          name: '营养师小王',
          avatar: 'https://randomuser.me/api/portraits/men/29.jpg',
        },
        content: '非常详细的分享！低碳饮食确实对很多人有效，但如你所说，一定要循序渐进，并确保营养均衡。',
        time: '2天前',
        likes: 15,
      },
      {
        id: 'c2',
        user: {
          name: '小丽',
          avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
        },
        content: '我也在尝试低碳饮食，但常感到无力，请问你有什么建议吗？',
        time: '1天前',
        likes: 3,
        replies: [
          {
            id: 'r1',
            user: {
              name: '李健康',
              avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
            },
            content: '你可能需要增加钠和钾的摄入，试试在水中加入少量盐和食用高钾食物如牛油果。',
            time: '1天前',
            likes: 5,
          }
        ]
      },
    ]
  };

  const handleLike = () => {
    if (isLiked) {
      setLikeCount(likeCount - 1);
    } else {
      setLikeCount(likeCount + 1);
    }
    setIsLiked(!isLiked);
  };

  // 渲染评论
  const renderComment = (comment, isReply = false) => {
    return (
      <View 
        key={comment.id}
        style={{ 
          marginLeft: isReply ? 40 : 0,
          marginTop: isReply ? 12 : 0,
          marginBottom: 16,
        }}
      >
        <View style={{ flexDirection: 'row' }}>
          <Image 
            source={{ uri: comment.user.avatar }} 
            style={{ 
              width: 36, 
              height: 36, 
              borderRadius: 18,
              marginRight: 12,
            }} 
          />
          <View style={{ flex: 1 }}>
            <View style={{ 
              backgroundColor: isDarkMode ? '#374151' : '#f3f4f6',
              borderRadius: 12,
              padding: 12,
            }}>
              <Text style={{ 
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
                marginBottom: 4,
              }}>
                {comment.user.name}
              </Text>
              <Text style={{ color: isDarkMode ? '#d1d5db' : '#4b5563' }}>
                {comment.content}
              </Text>
            </View>
            <View style={{ 
              flexDirection: 'row', 
              marginTop: 4,
              alignItems: 'center',
            }}>
              <Text style={{ 
                fontSize: 12, 
                color: isDarkMode ? '#9ca3af' : '#6b7280',
                marginRight: 12,
              }}>
                {comment.time}
              </Text>
              <TouchableOpacity 
                style={{ 
                  flexDirection: 'row', 
                  alignItems: 'center',
                  marginRight: 12,
                }}
              >
                <Ionicons 
                  name="heart-outline" 
                  size={14} 
                  color={isDarkMode ? '#9ca3af' : '#6b7280'} 
                  style={{ marginRight: 2 }}
                />
                <Text style={{ 
                  fontSize: 12, 
                  color: isDarkMode ? '#9ca3af' : '#6b7280',
                }}>
                  {comment.likes}
                </Text>
              </TouchableOpacity>
              {!isReply && (
                <TouchableOpacity>
                  <Text style={{ 
                    fontSize: 12, 
                    color: isDarkMode ? '#9ca3af' : '#6b7280',
                  }}>
                    回复
                  </Text>
                </TouchableOpacity>
              )}
            </View>
          </View>
        </View>

        {/* 渲染回复 */}
        {comment.replies && comment.replies.map(reply => renderComment(reply, true))}
      </View>
    );
  };

  return (
    <View style={{ 
      flex: 1,
      backgroundColor: isDarkMode ? '#1f2937' : '#f9fafb',
    }}>
      <ScrollView>
        <View style={{ padding: 16 }}>
          {/* 用户信息 */}
          <View style={{ 
            flexDirection: 'row', 
            alignItems: 'center', 
            marginBottom: 16,
          }}>
            <TouchableOpacity
              style={{ 
                width: 32, 
                height: 32, 
                borderRadius: 16,
                backgroundColor: isDarkMode ? '#374151' : '#f3f4f6',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 16,
              }}
              onPress={() => navigation.goBack()}
            >
              <Ionicons 
                name="arrow-back" 
                size={18} 
                color={isDarkMode ? 'white' : '#1f2937'} 
              />
            </TouchableOpacity>
            <TouchableOpacity
              style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}
              onPress={() => {/* 导航到用户页面 */}}
            >
              <Image 
                source={{ uri: experience.user.avatar }} 
                style={{ 
                  width: 44, 
                  height: 44, 
                  borderRadius: 22,
                  marginRight: 12, 
                }} 
              />
              <View>
                <Text style={{ 
                  fontWeight: 'bold',
                  color: isDarkMode ? 'white' : '#1f2937',
                  marginBottom: 2,
                }}>
                  {experience.user.name}
                </Text>
                <Text style={{ fontSize: 12, color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
                  {experience.time}
                </Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                backgroundColor: '#2563eb',
                paddingHorizontal: 12,
                paddingVertical: 6,
                borderRadius: 16,
              }}
            >
              <Text style={{ color: 'white', fontWeight: '500', fontSize: 12 }}>关注</Text>
            </TouchableOpacity>
          </View>

          {/* 标题 */}
          <Text style={{ 
            fontSize: 24,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 16,
          }}>
            {experience.title}
          </Text>

          {/* 内容 */}
          <Text style={{ 
            fontSize: 16,
            color: isDarkMode ? '#d1d5db' : '#4b5563',
            lineHeight: 24,
            marginBottom: 16,
          }}>
            {experience.content}
          </Text>

          {/* 图片 */}
          {experience.images.map((image, index) => (
            <Image 
              key={index}
              source={{ uri: image }} 
              style={{ 
                width: '100%', 
                height: 200, 
                borderRadius: 12,
                marginBottom: 12,
              }} 
              resizeMode="cover"
            />
          ))}

          {/* 标签 */}
          <View style={{ 
            flexDirection: 'row', 
            flexWrap: 'wrap',
            marginTop: 8,
            marginBottom: 16,
          }}>
            {experience.tags.map((tag, index) => (
              <View 
                key={index}
                style={{
                  backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
                  paddingHorizontal: 10,
                  paddingVertical: 5,
                  borderRadius: 20,
                  marginRight: 8,
                  marginBottom: 8,
                }}
              >
                <Text style={{ 
                  fontSize: 12, 
                  color: isDarkMode ? '#e0e0e0' : '#4b5563',
                }}>
                  #{tag}
                </Text>
              </View>
            ))}
          </View>

          {/* 互动栏 */}
          <View style={{ 
            flexDirection: 'row', 
            borderTopWidth: 1, 
            borderTopColor: isDarkMode ? '#4b5563' : '#f3f4f6',
            paddingTop: 16,
            marginBottom: 20,
          }}>
            <TouchableOpacity 
              style={{ 
                flexDirection: 'row', 
                alignItems: 'center', 
                marginRight: 24,
              }}
              onPress={handleLike}
            >
              <Ionicons 
                name={isLiked ? "heart" : "heart-outline"} 
                size={22} 
                color={isLiked ? "#ec4899" : (isDarkMode ? '#d1d5db' : '#6b7280')} 
                style={{ marginRight: 6 }}
              />
              <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
                {likeCount}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity style={{ 
              flexDirection: 'row', 
              alignItems: 'center',
              marginRight: 24,
            }}>
              <Ionicons 
                name="chatbubble-outline" 
                size={20} 
                color={isDarkMode ? '#d1d5db' : '#6b7280'} 
                style={{ marginRight: 6 }}
              />
              <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
                {commentCount}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity style={{ 
              flexDirection: 'row', 
              alignItems: 'center',
            }}>
              <Ionicons 
                name="share-social-outline" 
                size={20} 
                color={isDarkMode ? '#d1d5db' : '#6b7280'} 
                style={{ marginRight: 6 }}
              />
              <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
                分享
              </Text>
            </TouchableOpacity>
          </View>

          {/* 评论区 */}
          <View>
            <Text style={{ 
              fontSize: 18,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 16,
            }}>
              评论 ({experience.comments})
            </Text>

            {/* 评论输入框 */}
            <TouchableOpacity
              style={{ 
                flexDirection: 'row', 
                alignItems: 'center',
                backgroundColor: isDarkMode ? '#374151' : '#f3f4f6',
                borderRadius: 24,
                paddingHorizontal: 16,
                paddingVertical: 10,
                marginBottom: 20,
              }}
            >
              <Ionicons 
                name="chatbubble-outline" 
                size={20} 
                color={isDarkMode ? '#9ca3af' : '#6b7280'} 
                style={{ marginRight: 8 }}
              />
              <Text style={{ 
                color: isDarkMode ? '#9ca3af' : '#6b7280',
                flex: 1,
              }}>
                写下你的评论...
              </Text>
              <Ionicons 
                name="send" 
                size={18} 
                color={isDarkMode ? '#9ca3af' : '#6b7280'} 
              />
            </TouchableOpacity>

            {/* 评论列表 */}
            {experience.comments_data.map(comment => renderComment(comment))}
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

export default ExperienceDetailScreen; 